import styled from 'styled-components';
import { FaTrash } from 'react-icons/fa';
import Table from '../table/Table.component';

export const TableDiv = styled.div`
  overflow-x: auto;
  background-color: #ffffff;
`;

export const ClickableFaTrash = styled(FaTrash)`
  margin-right: 5px;
  color: #095aa5;

  :hover {
    cursor: pointer;
    color: #ff690a;
  }
`;

export const Service = styled.p`
  margin-left: 10px;
`;

export const TableCellInput = styled(Table.Cell)`
  width: 10%;
`;

export const Description = styled.span`
  color: #095aa5;

  :hover {
    cursor: pointer;
    color: #ff690a;
  }
`;
